/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateContactPersonToContractV1Dto = {
  /**
   * Role of the contact person in the contract
   */
  role?: CreateContactPersonToContractV1Dto.role;
  /**
   * Job title of the contact person in the contract
   */
  jobTitle?: string;
  /**
   * The uuid of the contact-person linked to this relation. As 8-4-4-4-12 format.
   */
  contactPersonId: string;
  /**
   * The uuid of the contract linked to this relation. As 8-4-4-4-12 format.
   */
  contractId: string;
};
export namespace CreateContactPersonToContractV1Dto {
  /**
   * Role of the contact person in the contract
   */
  export enum role {
    OWNER = 'Owner',
    TENANT = 'Tenant',
    PROPERTY_MANAGER = 'PropertyManager',
    FACILITY_MANAGER = 'FacilityManager',
    SERVICE_PROVIDER = 'ServiceProvider',
    OTHER = 'Other',
  }
}
